"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trees = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
class Trees extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.TREES,
            tags: [Tags_1.Tags.PLANT],
            cost: 13,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.temperature(-4)),
            metadata: {
                cardNumber: '060',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.plants(3)).plants(1);
                }),
                description: 'Requires -4 C or warmer. Increase your Plant production 3 steps. Gain 1 Plant.',
                victoryPoints: 1,
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.PLANTS, 3);
        player.plants++;
        return undefined;
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.Trees = Trees;
//# sourceMappingURL=Trees.js.map